import type { PreClaimsDispositionMethodListResponse } from './api';

export const normalizePreClaimsDispositionMethodList = (
  list: PreClaimsDispositionMethodListResponse,
): {
  label: string;
  value: string;
}[] => {
  if (!list) {
    return [];
  }
  return list.map((row) => ({
    label: row.value,
    value: row.key,
  }));
};
